export default __webpack_public_path__ + "static/Dalton-c155548cb48f233b130f54db2b0ca70f.jpeg";